import {Component, HostListener, OnInit} from "@angular/core";
import {Merchant, UserControllerService} from '../../../@services/gen';
import {AuthService} from '../../../@services/auth.service';
import {Location} from '@angular/common';
import {Router} from '@angular/router';
import {NotificationService} from '../../../@services/notification.service';
import {LocalstorageService} from '../../../@services/localstorage.service';
import {UserModel} from "../../../@models/user.model";
import {kickCashDrawerz} from "../../../@services/utils";
import {UserShiftService} from "../../../@services/user-shift.service";

@Component({
  selector: 'app-shift-opening',
  templateUrl: './shift-opening.component.html',
  styleUrls: ['./shift-opening.component.scss'],
})
export class ShiftOpeningComponent implements OnInit {
  title = 'Shift Opening Form';
  private merchant: Merchant;
  openingCash: number;
  user: UserModel;
  role: any;
  isMobile: boolean = false;

  constructor(
    private userService: UserControllerService,
    private customAuthService: AuthService,
    private ns: NotificationService,
    private ls: LocalstorageService,
    public location: Location,
    private router: Router,
    private userShiftService: UserShiftService
  ) {
    this.checkIsMobile();
  }

  ngOnInit(): void {
    this.merchant = this.ls.getMerchant();
    this.user = this.customAuthService.getUser();
    this.role = this.user.role;

    this.loadShift();

    kickCashDrawerz();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkIsMobile();
  }

  private checkIsMobile() {
    this.isMobile = window.innerWidth < 768; // You can adjust the threshold as needed
  }

  submit() {
    let dialogRef = this.ns.showNotification({
      message: 'Please wait...',
      icon: 'fa fa-sync',
      manualClose: true,
    });

    this.userService
      .startStopUserShiftPost({
        actionType: 'start',
        userShift: {
          openingCash: this.openingCash,
          merchant: {id: this.ls.getMerchant().id},
          dposUser: {id: this.user.userId}
        },
      })
      .subscribe((res) => {
        this.userShiftService.saveUserShift(res);
        dialogRef.close();
        this.router.navigate(['/']);
      });
  }

  cancel() {
    this.ls.clear();
    this.router.navigate(['/login']);
  }

  loadShift() {
    this.userService
      .getUserShiftPost({
        merchantId: this.merchant.id,
        cashierId: this.user.userId
      })
      .subscribe(
        (userShift) => {
          if(userShift){
            this.router.navigate(['/']);
          }
        },
        (error) => {
        }
      );
  }

}
